import { render, staticRenderFns } from "./ratingList.vue?vue&type=template&id=678078f0"
import script from "./ratingList.vue?vue&type=script&lang=js"
export * from "./ratingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports